import axios from 'axios'
import { router } from '../../router'

const BASE_URL = process.env.REACT_APP_API_BASE_URL

export const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(
  (config) => {
    const authUserId = localStorage.getItem('uid')

    if (authUserId) {
      config.headers['x-springforms-uid'] = authUserId
    }

    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.status === 401) {
      const pathname = router.state.location.pathname
      if (pathname !== '/log-in') {
        router.navigate(`/log-in?to=${pathname}`)
        localStorage.clear()
      }
    }
    return Promise.reject(err)
  }
)
